import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
    sectionTitle: {
        margin: 0,
        paddingLeft: 78,
        ...theme.typographyPresets.titleSmallBold,
        color: 'white',
        paddingBottom: 35,
        '@media(max-width: 1023px)': {
            paddingLeft: 40,
        },
        '@media (max-width: 767px)': {
            paddingLeft: 20,
            paddingBottom: 19,
        },
    },
    container: {
        paddingRight: 78,
        paddingLeft: 78,
        '@media(max-width: 1023px)': {
            padding: 40,
        },
        '@media (max-width: 767px)': {
            paddingLeft: 20,
            paddingRight: 20,
        },
    },
}))
